import '../whatsapp/whatsapp_text_message_content.js.coffee'
import '../whatsapp/whatsapp_image_message_content.js.coffee'
import '../whatsapp/whatsapp_location_message_content.js.coffee'
import '../whatsapp/whatsapp_voice_message_content.js.coffee'
import '../whatsapp/whatsapp_audio_message_content.js.coffee'
import '../whatsapp/whatsapp_document_message_content.js.coffee'
import '../whatsapp/whatsapp_video_message_content.js.coffee'
import '../whatsapp/whatsapp_contact_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappContentFactory
  types:
    text: Monitoring.Models.SocialContents.WhatsappTextMessageContent
    image: Monitoring.Models.SocialContents.WhatsappImageMessageContent
    location: Monitoring.Models.SocialContents.WhatsappLocationMessageContent
    voice: Monitoring.Models.SocialContents.WhatsappVoiceMessageContent
    audio: Monitoring.Models.SocialContents.WhatsappAudioMessageContent
    document: Monitoring.Models.SocialContents.WhatsappDocumentMessageContent
    video: Monitoring.Models.SocialContents.WhatsappVideoMessageContent
    contacts: Monitoring.Models.SocialContents.WhatsappContactMessageContent


  create: (socialContent) ->
    type = @types[socialContent?.whatsappMessage?.messageType]
    if type
      whatsapp_content = new type(socialContent)
      parent = socialContent.parent
      if parent
        parent_type =  @types[parent.whatsappMessage.messageType]
        parent_content = new parent_type(parent)
        whatsapp_content.setParent(parent_content)
      whatsapp_content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'whatsapp' and socialContent.data and socialContent.sub_type
